import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

import staff from './staff';
import gift from './gift';
import alert from './alert';
import { emoticon } from './emoticon';

export type CheeersRootState = any;

Vue.use(Vuex);

const store: StoreOptions<CheeersRootState> = {
  state: {
    loading: false,
    navigator: '/',
  },
  getters: {
    isLoading: (state) => state.loading,
  },
  mutations: {
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
    updateNavigator: (state, navigator) => {
      state.navigator = navigator;
    }
  },
  actions: {
    startLoading: ({ commit }) => {
      commit('startLoading');
    },
    stopLoading: ({ commit }) => {
      commit('stopLoading');
    },
    updateNavigator: ({ commit }, navigator) => {
      commit('updateNavigator', navigator);
    }
  },
  modules: {
    staff,
    gift,
    alert,
    emoticon,
  },
};

export default store;
